<template>
  <Screen/>
</template>

<script>
  import Screen from './components/Screen.vue'

  export default {
    components: {
      Screen
    }
  }
</script>

<style>
  @import url("https://fonts.googleapis.com/css?family=Open+Sans");

  html {
    font-size: 120px;

    background: black;
    color: white;

    font-family: 'Open Sans', sans-serif;
  }
</style>
